/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.controllers')
    .controller('AppCtrl',
        ["$rootScope", "$scope", "$routeParams", "$location", "$sce", "$window", "$timeout", "$dialog", "$http", "$filter", "Loader", "Auth", "UserData", "AppData", "SiteData",
            "Helper", "MessageSrv", "CompanyView", "CompanyData", "StoreAppView", "StoreAppData", "DateSrv", "App", "AppAttribute", "AppSrv", "NotificationView", "NotificationData",
            "UserActionManager", "AuditTrailSrv", "LanguageManager", "gettextCatalog", "$locale", "DayData", "$route", "ReportModelData", "$templateCache", "CurrencyManager",
            "HumanResourceData", "CureCategoryView", "ProductCategoryView", "LoyaltyCardCategoryView", "TreeMovementDirection",
            "PeriodType", "TypeOfModification", "PeriodStat", "StatPeriodType", "UserActionSrv", "DayHrData", "PhysicalResourceData", "DayPrData", "CustomerData",
            "BookingData", "LaunchDarklyFeatureFlagData", "LaunchDarklyFeatureFlagSrv", "MonitoringApplication", "MonitoringSrv", "MonitoringHealthState",
            "CompanyTypes", "StoreAppCode", "Countries", "ExternalServiceLoader", "MonitoringUsageDataSrv", "MonitoringUsageConstants", "MeasureStore", "TimeMeasures", "Decorators", "moment", "Constants", "AppCode", "EnvironmentSrv",
            "Environment_Constant", "$interval", "bugsnag", "NotificationSrv", "Brand", "Timers", "OfferManager", "BillingManagerSrv",
            "MarketPlaceSpecifications", "Idle", "Offers", "Images", "CustomerSrv", "CompanyMigrationSettingsData", "CompanyMigrationSettingsSrv", "PaymentServiceSrv",
            function ($rootScope, $scope, $routeParams, $location, $sce, $window, $timeout, $dialog, $http, $filter, Loader, Auth, UserData, AppData, SiteData,
                      Helper, MessageSrv, CompanyView, CompanyData, StoreAppView, StoreAppData, DateSrv, App, AppAttribute, AppSrv, NotificationView, NotificationData,
                      UserActionManager, AuditTrailSrv, LanguageManager, gettextCatalog, $locale, DayData, $route, ReportModelData, $templateCache, CurrencyManager,
                      HumanResourceData, CureCategoryView, ProductCategoryView, LoyaltyCardCategoryView, TreeMovementDirection,
                      PeriodType, TypeOfModification, PeriodStat, StatPeriodType, UserActionSrv, DayHrData, PhysicalResourceData, DayPrData, CustomerData,
                      BookingData, LaunchDarklyFeatureFlagData, LaunchDarklyFeatureFlagSrv, MonitoringApplication, MonitoringSrv, MonitoringHealthState,
                      CompanyTypes, StoreAppCode, Countries, ExternalServiceLoader, MonitoringUsageDataSrv, MonitoringUsageConstants, MeasureStore, TimeMeasures, Decorators, moment, Constants, AppCode, EnvironmentSrv,
                      Environment_Constant, $interval, bugsnag, NotificationSrv, Brand, Timers, OfferManager, BillingManagerSrv,
                      MarketPlaceSpecifications, Idle, Offers, Images, CustomerSrv, CompanyMigrationSettingsData, CompanyMigrationSettingsSrv, PaymentServiceSrv) {

                console.time("Application");
                gettextCatalog.debug = false;
                $scope.isUnsavedBookingView = false;
                const IS_PERIODIC_GET_USER_ACTION_ACTIVATED = true;
                let timers = [];
                let intervals = [];

                //surcharge de la directive permettant de ssaisir des emails
                $templateCache.put('ngTagsInput/tags-input.html',
                    "<div class=\"host\" tabindex=\"-1\" ng-click=\"eventHandlers.host.click()\" ti-transclude-append><div class=\"tags\" ng-class=\"{focused: hasFocus}\"><input class=\"input\" autocomplete=\"off\" ng-model=\"newTag.text\" ng-model-options=\"{getterSetter: true}\" ng-keydown=\"eventHandlers.input.keydown($event)\" ng-focus=\"eventHandlers.input.focus($event)\" ng-blur=\"eventHandlers.input.blur($event)\" ng-paste=\"eventHandlers.input.paste($event)\" ng-trim=\"false\" ng-class=\"{'invalid-tag': newTag.invalid}\" ng-disabled=\"disabled\" ti-bind-attrs=\"{type: options.type, placeholder: options.placeholder, tabindex: options.tabindex, spellcheck: options.spellcheck}\" ti-autosize><ul class=\"tag-list\"><li class=\"tag-item\" ng-repeat=\"tag in tagList.items track by track(tag)\" ng-class=\"getTagClass(tag, $index)\" ng-click=\"eventHandlers.tag.click(tag)\"><ti-tag-item scope=\"templateScope\" data=\"::tag\"></ti-tag-item></li></ul></div></div>"
                );

                $scope.ad = {
                    domain: null,
                    sDm: null,
                    ssDomain: null,
                    themeClass: '',
                    showSubMenu: null,
                    index: 0,
                    showSubMenuPromise: null,
                    subMenuLeft: 0,
                    firstLoadingProcess: !Loader.loaded,
                    dataLoaded: Loader.loaded,
                    dataLoadedError: false,
                    unauthorizedUser: false,
                    loggedUser: null,
                    smsReminder: null,
                    currentUser: Auth.getCurrentUser(),
                    companyName: Auth.getCompanyName(),
                    companyCode: Auth.getCompanyCode(),
                    currentSiteName: "",
                    companyMigrationSettings: CompanyMigrationSettingsData.companyMigrationSettings,
                    headerTopStyle: null,
                    webSiteAdminUrl: $sce.trustAsResourceUrl("/" + Auth.getCompanyCode() + "/admin/" + Auth.getToken()),
                    kiuteProAppIframeUrl: '',
                    isMobileOrPadTouchScreen: false,
                    displayStartWindow: Helper.displayStartWindow,
                    managerMode: Helper.managerMode,
                    isMarketplaceCompliant: null,
                    isAlreadyOpenTab: false,
                    topHeaderPixel: '0px',
                    bodyPixel: '41px',
                    isAdminNotGroup: Auth.isAdminNotGroup(),
                    view: {
                        companyView: null,
                        storeAppsView: [],
                        subscriptions: {
                            sub: {annual: null}
                        },
                        notificationsView: [],
                        notificationsIsLoading: false,
                        nbNotificationsUnread: 0,
                        notificationDisplayParameters: null,
                        userActions: [],
                        typeOfModification: TypeOfModification
                    },
                    addons: {
                        sub: {
                            smsCampaign: false,
                            giftItem: false,
                            loyaltyCard: false,
                            cure: false,
                            bookingSmsSecurity: false,
                            optionReserveWithGoogle: false,
                            optionLeCiseau: false,
                            optionLeCiseauLight :false,
                            withoutTill: false,
                            clientFullAccess: false,
                            onlineReservationAccess: false,
                            websiteAccess: false,
                            websitePaymentAccess: false,
                            statisticsAccess: false,
                            statisticsFullAccess: false,
                            nativeAppAccess: false,
                            posAccess: false,
                            booksyButtonAccess: false,
                        },
                        options: {
                            iZettlePayment: false
                        }
                    },
                    absUrl: $location.absUrl(),
                    treeMovementDirection: TreeMovementDirection,
                    dialog: {
                        website: false,
                        marketplace: false
                    },
                    brand: Brand,
                    offerManager: OfferManager,
                    offers: Offers,
                    billingManager: {
                        managementTool: null,
                        companyId: null,
                        loading: false,
                        loaded: false
                    },
                    bookingStatusImage: Images.saleStatus,
                    companyTypes: CompanyTypes,
                    areMigrationInformationComplete: false,
                    migrationInfoCountdownDate: null,
                    monitoringUsageConstants: MonitoringUsageConstants
                };
                $scope.ngAppCustomerIframe = undefined;
                $scope.popInterval = null;

                window.hideElementsForSelenium = function () {
                    $("#chmln").hide();
                    $("#intercom-container").hide();
                };

                window.goToReport = function (reportId, beginDayId, endDayId, dashboardId, reportIndex) {
                    $location.path("/report/" + reportId + "/" + beginDayId + "/" + endDayId + "/" + dashboardId + "/" + reportIndex);
                    $route.reload();
                    return "OK";
                };

                window.getReportInfo = function (reportId) {
                    var report = ReportModelData.getById(reportId);
                    report.height = ($(".chart-zone:first") && $(".chart-zone:first").height()) ? $(".chart-zone:first").height() : $(".flexy-report-detail:first").height();
                    return angular.toJson(report);
                };

                const onNotificationDestroy = $rootScope.$on('onNotification', function (_, notification) {
                    if (NotificationData.isLoaded) {
                        $scope.loadNotificationIfStatusValid(notification);
                        $scope.updateNbNotificationsUnread();
                        $scope.safeApply();
                    } else {
                        $scope.countUnreadNotifications();
                    }
                });

                const fxbInvalidTokenDestroy = $rootScope.$on('fxbInvalidToken', function () {
                    let opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/invitationDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["title"] = gettextCatalog.getString("Information");
                                tableModel["label"] = gettextCatalog.getString("Vous n'êtes plus identifé. Nous vous invitons à vous reconnecter.");
                                tableModel["buttonLabel"] = gettextCatalog.getString("Se reconnecter");
                                tableModel["buttonClass"] = "btn btn-success";
                                tableModel["dialogId"] = "refreshDialogInvalidToken";
                                return tableModel;
                            }
                        }
                    };
                    $dialog.dialog(opts).open().then(function (result) {
                        if (result) {
                            Auth.afterLogout(Auth.getCompanyCode());
                        }
                    });
                });

                const fxbInvalidChannelDestroy = $rootScope.$on('fxbInvalidChannel', function () {
                    let errorMessage = gettextCatalog.getString("Votre session a expiré");

                    let opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/refreshDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                let tableModel = [];
                                tableModel["label"] = errorMessage + ". " + gettextCatalog.getString("Nous vous invitons à rafraîchir la page.");
                                tableModel["dialogId"] = "refreshDialogInvalidChannel";
                                return tableModel;
                            }
                        }
                    };
                    $dialog.dialog(opts).open().then(function (result) {
                        if (result) {
                            location.reload();
                        }
                    });
                });

                if (navigator.userAgent.indexOf("Android") != -1 || navigator.userAgent.indexOf("iPhone OS") != -1 || navigator.userAgent.indexOf("iPad") != -1)
                    $scope.ad.isMobileOrPadTouchScreen = true;



                $scope.canAccessLiveEdit = function () {
                    return LanguageManager.canAccessLiveEdit();
                };

                $scope.isEnglishLanguage = function () {
                    return LanguageManager.isEnglishLanguage();
                };

                $scope.isFrenchLanguage = function () {
                    return LanguageManager.isFrenchLanguage();
                };

                $scope.isEuroCurrency = function () {
                    return CurrencyManager.isEuroCurrency();
                };

                $scope.isFrance = function () {
                    let countryCode = LanguageManager.getCountryCode();
                    return Countries.FRANCE.countryCode === countryCode;
                };

                $scope.getCurrencySymbol = function () {
                    return CurrencyManager.getCurrencySymbol();
                };

                $scope.$watch('online', function (newStatus) {
                    if (!newStatus) {//offline
                        var msgSrv = gettextCatalog.getString("Attention, votre connexion internet est inactive");
                        MessageSrv.send("alert", msgSrv + " !");
                    } else if ($scope.ad.loggedUser)
                        MessageSrv.cleanMessage();
                });

                $scope.emitUserActionAction = function (userAction) {
                    if (userAction) {
                        $rootScope.$emit("onNotificationAction", userAction);
                    }
                };

                $scope.emitNotificationAction = function (notificationView) {
                    if (notificationView) {
                        notificationView.updateAsRead();
                        $scope.updateNbNotificationsUnread();
                        $rootScope.$emit("onNotificationAction", notificationView);
                    }
                };
                $scope.emitNotificationAction = function (notificationView) {
                    if (notificationView && notificationView.data) {
                        notificationView.updateAsRead();
                        $scope.updateNbNotificationsUnread();
                        if ($scope.ad.domain != "planningPos") {
                            if (notificationView.data.globalObjectType == "Booking")
                                $scope.goToDomain("planningPos", "planning");
                            else
                                $scope.goToDomain("planningPos", "pos");
                            const timer = $timeout(() => {
                                $rootScope.$emit("onNotificationAction",notificationView);
                            }, 1000);
                            timers.push(timer);
                        } else
                            $rootScope.$emit("onNotificationAction", notificationView);
                    }
                };

                $scope.getTooltip = function (selectedCategoryView, rootCategoryView) {
                    let tooltipText = null, tooltipName = null;
                    if (selectedCategoryView instanceof CureCategoryView) {
                        tooltipName = gettextCatalog.getString("une cure");
                    } else if (selectedCategoryView instanceof LoyaltyCardCategoryView) {
                        tooltipName = gettextCatalog.getString("une carte de fidélité");
                    } else if (selectedCategoryView instanceof ProductCategoryView) {
                        tooltipName = gettextCatalog.getString("un produit");
                    } else {
                        tooltipName = gettextCatalog.getString("une prestation");
                    }
                    if (selectedCategoryView === rootCategoryView) {
                        tooltipText = gettextCatalog.getString("à la racine")
                    } else {
                        tooltipText = gettextCatalog.getString(" dans ") + " " + selectedCategoryView.label;
                    }
                    if (!selectedCategoryView && !rootCategoryView) {
                        return gettextCatalog.getString("Ajouter une catégorie") + " " + tooltipText
                    } else {
                        return gettextCatalog.getString("Ajouter") + " " + tooltipName + " " + tooltipText
                    }
                };
                $scope.getGiftItemTooltip = function (editionType, customerView) {
                    let giftItemType = null, giftItemCustomer = null, tooltipText = null;
                    if (editionType === "printOnTicket") {
                        giftItemType = gettextCatalog.getString("à imprimer");
                    } else if (editionType === "email") {
                        giftItemType = gettextCatalog.getString("envoyé par email");
                    } else {
                        giftItemType = ''
                    }
                    if (customerView != null && customerView !== undefined) {
                        giftItemCustomer = customerView.label;
                        tooltipText = gettextCatalog.getString("attribué à");

                    } else {
                        giftItemCustomer = '';
                    }
                    return gettextCatalog.getString("Chèque cadeau") + " " + giftItemType + " " + tooltipText + " " + giftItemCustomer;
                };

                $scope.getCategorytTooltip = function (parentCategoryView, categoryRootView, direction) {
                    let tooltipText = null,
                        tooltipLabel = parentCategoryView.label;

                    if (parentCategoryView === categoryRootView) {
                        tooltipText = gettextCatalog.getString("à la racine");
                        tooltipLabel = "";
                    } else {
                        tooltipText = gettextCatalog.getString("à la catégorie");
                    }
                    return direction.action + " " + tooltipText + " " + tooltipLabel;
                };


                $scope.updateAsUnRead = function (notificationView) {
                    if (notificationView) {
                        notificationView.updateAsUnRead();
                        $scope.updateNbNotificationsUnread();
                    }
                };

                $scope.updateNbNotificationsUnread = function () {
                    $scope.ad.view.nbNotificationsUnread = 0;
                    for (var i = 0; i < $scope.ad.view.notificationsView.length; i++)
                        if ($scope.ad.view.notificationsView[i].status != "read")
                            $scope.ad.view.nbNotificationsUnread++;
                };

                $scope.countUnreadNotifications = function () {
                    NotificationSrv.countUnread()
                        .then((data) => {
                            if (data && data.notificationNumber !== undefined) {
                                const timer = $timeout(() => {
                                    NotificationData.unreadNotifications = data.notificationNumber;
                                    $scope.ad.view.nbNotificationsUnread = data.notificationNumber;
                                }, 100);
                                timers.push(timer);
                            }
                        })
                        .catch((error) => {
                            bugsnag.notify("NotificationSrv.countUnread - Error during fetching notification number", `NotificationSrv countUnread failure. Error : ${error.message}`, {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
                        });
                }

                $scope.readAllNotifications = function () {
                    for (var i = 0; i < $scope.ad.view.notificationsView.length; i++)
                        if ($scope.ad.view.notificationsView[i].status != "read")
                            $scope.ad.view.notificationsView[i].updateAsRead();
                    $scope.updateNbNotificationsUnread();
                };

                $scope.loadNotifications = function () {
                    if (NotificationData.isLoaded) {
                        $scope.loadNotificationViews();
                    } else {
                        $scope.ad.view.notificationsIsLoading = true;
                        NotificationSrv.query(
                            function (data) {
                                $scope.loadNotificationViews();
                                $scope.ad.view.notificationsIsLoading = false;
                            },
                            function (data) {
                                $scope.ad.view.notificationsIsLoading = false;
                            });
                    }
                };

                $scope.goToNotificationPage = function () {
                    if ($scope.ad.domain === 'planningPos') {
                        $scope.goToSubDomain('notification');
                        $scope.loadNotifications();
                    } else if ($scope.ad.sDm !== 'notification') {
                        $scope.goToDomain('planningPos', 'notification');
                    }
                };

                $scope.loadOrCountNotification = function () {
                    if (!NotificationData.isLoaded) {
                        if ($scope.ad.domain === "planningPos" && $scope.ad.sDm === "notification") {
                            $scope.loadNotifications();
                        } else {
                            $scope.countUnreadNotifications();
                        }
                    } else {
                        $scope.loadNotificationViews();
                    }
                }

                $scope.loadNotificationViews = function () {
                    let notifications = NotificationData.indexNotifications;
                    $scope.ad.view.notificationsView = [];
                    for (let i = 0; i < notifications.length; i++) {
                        $scope.loadNotificationIfStatusValid(notifications[i]);
                    }
                    $scope.updateNbNotificationsUnread();
                    $scope.loadAgendaNotificationParameters('internet');
                };

                $scope.loadNotificationIfStatusValid = function (notification) {
                    let notificationView = new NotificationView(notification, NotificationData.getIndexOf(notification));
                    if (notificationView.data && notificationView.data.status != "soldProcess" && notificationView.data.status != "advanceProcess" && notificationView.data.status != "failed") {
                        $scope.ad.view.notificationsView.push(notificationView);
                    }
                };

                $scope.handleIntercomAndSdm = function (domain, sDm) {
                    $scope.manageIntercomVisbility(domain, sDm);

                    if (sDm !== undefined && sDm) {
                        $scope.ad.sDm = sDm;
                    } else {
                        $scope.ad.sDm = null;
                    }
                    $location.search("sDm", $scope.ad.sDm);
                    $rootScope.$emit("goToDomainCalled");

                    const timer = $timeout(() => {
                        $scope.clearDailyStatPrecalculatedDatas();
                    });
                    timers.push(timer);

                    document.dispatchEvent(new Event("lokalise-update-elements"));
                };

                $scope.$on("editedBookingStatusToAppCtrl", function (evt, data) {
                    $scope.isUnsavedBookingView = data;
                });

                $scope.goToDomain = function (domain, sDm) {
                    if ($scope.ad.domain !== domain || $scope.ad.sDm !== sDm) {
                        if ($scope.ad.sDm !== 'planning') {
                            $scope.isUnsavedBookingView = false;
                        } else {
                            $scope.$broadcast("editedBookingStatusOnPlanningPosCtrl");
                        }

                        if ($scope.isUnsavedBookingView) {
                            $scope.$broadcast("displayUnsavedMessageOnPlanningPosCtrl");
                        } else {
                            if ($scope.ad.domain !== domain) {
                                if ($scope.ad.domain === "webSite") {
                                    Loader.forceReload = true;
                                }
                                $location.path("/app/" + domain);
                            }
                            $scope.handleIntercomAndSdm(domain, sDm);
                        }
                    }
                };

                $scope.monitoringUsage = function (nameMonitoring) {
                    MonitoringUsageDataSrv.logUsageData(nameMonitoring);
                }
                $scope.goToCustomerOrDownload = function () {
                    if ($scope.ad.loggedUser.company.type === CompanyTypes.CANCELED.value) {
                        $rootScope.isDownloadCustomers = true;
                        let format = Constants.EXPORT_FORMAT.XLSX;
                        CustomerSrv.getCustomerExport().then(content => {
                            let hiddenElement = document.createElement('a');
                            const blob = new Blob([content.data], { type: format.hrefAttachment });
                            hiddenElement.href = URL.createObjectURL(blob);
                            hiddenElement.download = `kiute-pro-clients.${format.fileExtension}`;
                            document.body.appendChild(hiddenElement);
                            hiddenElement.click();
                            $rootScope.isDownloadCustomers = false;
                        });
                    } else {
                        $scope.goToDomain('planningPos','customer');
                    }
                }

                $scope.goToSSDomain = function (domain, sDm, ssDm) {
                    if ($scope.ad.domain !== domain) {
                        if ($scope.ad.domain === "webSite") {
                            Loader.forceReload = true;
                        }
                        if (ssDm) {
                            $location.path("/app/" + domain + "/" + ssDm);
                        } else {
                            $location.path("/app/" + domain);
                        }
                    }
                    $scope.handleIntercomAndSdm(domain, sDm);
                };

                $scope.clearDailyStatPrecalculatedDatas = function () {
                    console.info("clearDailyStatPrecalculatedDatas");
                    for (var i = 0; i < DayData.indexDays.length; i++) {
                        DayData.indexDays[i].clearPrecalculatedStatDatas();
                    }
                };

                $scope.goToSubDomain = function (sDm) {
                    if (sDm !== undefined && sDm)
                        $scope.ad.sDm = sDm;
                    else
                        $scope.ad.sDm = null;
                    $location.search("sDm", $scope.ad.sDm);

                    $scope.manageIntercomVisbility($scope.ad.domain, sDm);

                    document.dispatchEvent(new Event("lokalise-update-elements"));
                };

                $scope.toggleSubMenu = function (showSubMenu, now, event) {
                    if (event && event.currentTarget) {
                        $scope.ad.subMenuLeft = event.currentTarget.offsetLeft + "px";
                    }
                    if ($scope.ad.showSubMenu == showSubMenu) {
                        $scope.showSubMenu(null, now);
                    } else {
                        $scope.showSubMenu(showSubMenu, now);
                    }
                };

                $scope.reloadPage = function () {
                    window.location.reload(false);
                };

                $scope.showSubMenu = function (showSubMenu, now) {
                    if ($scope.ad.showSubMenuPromise)
                        $timeout.cancel($scope.ad.showSubMenuPromise);
                    if (showSubMenu)
                        if (now)
                            $scope.ad.showSubMenu = showSubMenu;
                        else
                            $scope.ad.showSubMenuPromise = $timeout(
                                function () {
                                    $scope.ad.showSubMenu = showSubMenu;
                                }
                                , 10000);
                    else if (now)
                        $scope.ad.showSubMenu = null;
                    else
                        $scope.ad.showSubMenuPromise = $timeout(
                            function () {
                                $scope.ad.showSubMenu = null;
                            }
                            , 10000);
                };
                $scope.onExit = function () {
                    AuditTrailSrv.createAndSave("40");//Stop usage
                };

                $scope.generateAuditTrail = function (code) {
                    AuditTrailSrv.createAndSave(code);//Stop usage
                };

                $window.onbeforeunload = $scope.onExit;

                $scope.logout = function (alreadyDisconnected) {
                    $dialog.dialog({
                        backdrop: true,
                        backdropClick: false,
                        keyboard: !alreadyDisconnected,
                        templateUrl: alreadyDisconnected ? '/partials/global/infoDialog.html' : '/partials/global/generalConfirm.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                let tableModel = [];
                                if (alreadyDisconnected) {
                                    tableModel.label = gettextCatalog.getString("Votre session a expiré. Veuillez vous connecter à nouveau.");
                                } else {
                                    tableModel.question = gettextCatalog.getString("Souhaitez-vous vous déconnecter") + " ?";
                                    tableModel.isEnglishLanguage = $scope.isEnglishLanguage; // FIXME not used in generalConfirm.html model
                                }
                                return tableModel;
                            }
                        }
                    })
                        .open()
                        .then(function (result) {
                            if (result) {
                                Auth.logout();
                            }
                        });
                };

                /**
                 * TODO purge (ad.loggedUser and company checks ?) and simplify code
                 */
                $scope.loadSubscriptionStoreAppActivities = function () {
                    $scope.loadSubApp(StoreAppCode.OPTION_WITHOUT_TILL_STORE_APP_CODE);
                    $scope.loadSubApp(StoreAppCode.OPTION_POS_APP_CODE);
                    $scope.loadSubApp(StoreAppCode.OPTION_SMS_CAMPAIGN_APP_CODE);
                    $scope.loadSubApp(StoreAppCode.OPTION_SMS_REMINDER_APP_CODE);
                    $scope.loadSubApp(StoreAppCode.OPTION_GIFT_ITEM_APP_CODE);
                    $scope.loadSubApp(StoreAppCode.OPTION_LOYALTY_CARD_APP_CODE);
                    $scope.loadSubApp(StoreAppCode.OPTION_CURE_APP_CODE);
                    $scope.loadSubApp(StoreAppCode.OPTION_BOOKING_SMS_SECURITY_APP_CODE);
                    $scope.loadSubApp(StoreAppCode.OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE);
                    $scope.loadSubApp(StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE);

                    $scope.loadFeaturesAccess();
                };

                $scope.loadSubApp = function (code) {
                    if ($scope.ad.loggedUser && $scope.ad.loggedUser.company) {
                        if (code === StoreAppCode.OPTION_POS_APP_CODE) {
                            $scope.ad.addons.sub[code] = $scope.ad.loggedUser.company.hasSubscriptionActive(code) && !$scope.ad.loggedUser.company.hasSubscriptionActive(StoreAppCode.OPTION_WITHOUT_TILL_STORE_APP_CODE);
                        } else {
                            $scope.ad.addons.sub[code] = $scope.ad.loggedUser.company.hasSubscriptionActive(code);
                        }
                    }
                };

                $scope.loadFeaturesAccess = function() {
                    if ($scope.ad.loggedUser && $scope.ad.loggedUser.company) {
                        $scope.ad.addons.sub.clientFullAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_CLIENT_FULL);
                        $scope.ad.addons.sub.onlineReservationAccess = OfferManager.hasCompanyAccessToOnlineReservation($scope.ad.loggedUser.company);
                        $scope.ad.addons.sub.websiteAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_WEBSITE);
                        $scope.ad.addons.sub.websitePaymentAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_WEBSITE_PAYMENT);
                        $scope.ad.addons.sub.statisticsAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_STATISTICS);
                        $scope.ad.addons.sub.statisticsFullAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_STATISTICS_FULL);
                        $scope.ad.addons.sub.nativeAppAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_NATIVE_APP_APP_CODE);
                        $scope.ad.addons.sub.posAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_POS_APP_CODE);
                        $scope.ad.addons.sub.booksyButtonAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_BOOKSY_BUTTON);
                    }
                };

                $scope.loadIZettleAppAttribute = function () {
                    $scope.loadAppAttribute(AppCode.POS_APP, AppCode.POS_ATTRIBUTE_IZETTLE_PAYMENT);
                };

                $scope.loadAppAttribute = function (appCode, appAttributeCode) {
                    if ($scope.ad.loggedUser && $scope.ad.loggedUser.company) {
                        let app = AppData.getAppByCode(appCode);
                        if (app) {
                            let appAttribute = app.getAppAttribute(appAttributeCode);
                            if (appAttribute) {
                                if (appAttribute.value === "true") {
                                    $scope.ad.addons.options[appAttributeCode] = true;
                                } else if (appAttribute.value === "false") {
                                    $scope.ad.addons.options[appAttributeCode] = false;
                                } else {
                                    $scope.ad.addons.options[appAttributeCode] = appAttribute.value;
                                }
                            }
                        }
                    }
                };

                $scope.reloadApplication = function () {
                    var absUrl = $location.absUrl();
                    if (absUrl.indexOf("/connect/") != -1)
                        $window.open("/connect/" + Auth.getCompanyCode(), "_self"); //clear page
                    else if (absUrl.indexOf("/fxbAdmin/") != -1)
                        $window.open("/fxbAdmin/" + Auth.getCompanyCode(), "_self");   //clear page
                    else
                        $window.open("/", "_self");   //clear page
                };

                $scope.reactivateAccount = function () {
                    $window.open("https://calendly.com/d/z3j-9ns-wdn/booksy-reactivation-mon-abonnement-kiute?month=2023-02");
                };

                $scope.manageIntercomVisbility = function (domain, sDm) {
                    if (domain === "planningPos" && sDm === "planning") {
                        $scope.setIntercomSettings(false);
                    } else {
                        $scope.setIntercomSettings(true);
                    }
                };

                $scope.setIntercomSettings = function (isVisible) {
                    if (window.Intercom) {
                        window.intercomSettings = {
                            app_id: this.getIntercomAppId(),
                            hide_default_launcher: !isVisible
                        };
                        window.Intercom('update', intercomSettings);
                    }
                };

                $scope.getIntercomAppId = function () {
                    let appId = null;
                    if ($scope.ad.loggedUser.serverIdentification.applicationId === "bsiflexyprod") {
                        appId = "xxmtyv4q";
                    } else {
                        appId = "hnour6wu";
                    }
                    return appId;
                };

                $scope.initDisplayStartWindow = function (type) {
                    if (!$scope.ad.isAlreadyOpenTab) {
                        $scope.setDisplayStartWindow(null, true);

                        if ($scope.ad.loggedUser.company.type === CompanyTypes.MIGRATION.value
                          || $scope.ad.loggedUser.company.type === CompanyTypes.BILLINGISSUE.value
                          || $scope.ad.loggedUser.company.type === CompanyTypes.BLOCKED.value
                          || $scope.ad.loggedUser.company.type === CompanyTypes.BILLINGBLOCKED.value
                          || $scope.ad.loggedUser.company.type === CompanyTypes.CANCELED.value) {
                            if ($scope.ad.loggedUser.company.companyPaymentData &&
                              $scope.ad.loggedUser.company.type !== CompanyTypes.MIGRATION.value &&
                              $scope.ad.loggedUser.company.type !== CompanyTypes.CANCELED.value) {
                                $scope.ad.loggedUser.company.companyPaymentData.isValid = false;//force invalid payment
                            }
                            $scope.setDisplayStartWindow($scope.ad.loggedUser.company.type);
                        } else {
                            if (type !== undefined && type != null)
                                $scope.setDisplayStartWindow(type);
                            else if ($scope.ad.loggedUser.company.type == "newAccount") {
                                var appMessage = AppData.getAppByCode("appMessage");
                                if (!appMessage) {
                                    appMessage = new App();
                                    appMessage.setCode("appMessage");
                                }
                                var appAttrVideo = appMessage.getAppAttribute("hasStarted");
                                if (!appAttrVideo || appAttrVideo.value != "true")//direct access on agenda
                                {
                                    appMessage.addAppAttribute(new AppAttribute("hasStarted", "true"));
                                    AppSrv.save(appMessage);
                                } else
                                    $scope.setDisplayStartWindow("newAccount");

                            }
                        }
                    }
                };

                $scope.setAppValue = function (appCode, attrCode, value) {
                    var appMessage = AppData.getAppByCode(appCode);
                    if (!appMessage) {
                        appMessage = new App();
                        appMessage.setCode(appCode);
                    }
                    var appAttr = appMessage.getAppAttribute(attrCode);
                    if (!appAttr)
                        appMessage.addAppAttribute(new AppAttribute(attrCode, value));
                    else
                        appAttr.value = value;
                    AppSrv.save(appMessage);
                };

                $scope.closeAnnualMessage = function () {
                    $scope.setDisplayStartWindow(null);
                    $scope.setAppValue('appMessage', 'annualMode', 'true')
                    var msgLabel = gettextCatalog.getString("Si vous souhaitez l'activer plus tard, rendez-vous dans votre espace facturation");
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/infoDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["label"] = msgLabel + ".";
                                tableModel["isEnglishLanguage"] = $scope.isEnglishLanguage;
                                return tableModel;
                            }
                        }
                    };

                    var d = $dialog.dialog(opts);
                    d.open();
                };

                $scope.safeApply = function (fn) {
                    if ($scope.$root) {
                        var phase = $scope.$root.$$phase;
                        if (phase == '$apply' || phase == '$digest') {
                            if (fn && (typeof (fn) === 'function')) {
                                fn();
                            }
                        } else {
                            $scope.$apply(fn);
                        }
                    } else
                        $scope.$apply(fn);
                };

                $scope.setDisplayStartWindow = function (displayStartWindow, isFirstInit) {
                    Helper.displayStartWindow = displayStartWindow;
                    $scope.ad.displayStartWindow = displayStartWindow;
                    if (displayStartWindow === null && !isFirstInit) {
                        ExternalServiceLoader.initChameleon($scope.ad.loggedUser, OfferManager.computeCompanyOfferCode($scope.ad.loggedUser.company));
                    }
                };

        $scope.closeStartWindowAndGoToBilling = function() {
            $scope.setDisplayStartWindow(null);
            $scope.goToBilling();
        };

        $scope.goToBilling = function() {
            $scope.ad.managerMode ? $scope.goToDomain('flexyBeauty', 'invoice') : $scope.toggleManagerMode(true);
        };

        $scope.filterInvoicesView = function (invoicesView) {
             if (invoicesView && $scope.ad.billingManager.managementTool) {
                 invoicesView = invoicesView.filter(invoice => invoice.type === 'onlinePayment')
             }
             return invoicesView;
        };

        $scope.redirectToAlma = function() {
            window.open("https://link.booksy.com/e/I7P7dF7qPzb?c=" + $scope.ad.loggedUser.company.code, "_blank");
        }

        $scope.loadBillingManagerIfNeeded = function() {
            if (!$scope.ad.billingManager.loaded) {
                $scope.ad.billingManager.loading = true;
                return BillingManagerSrv.getBillingManager().then(
                    data => {
                        if (data) {
                            $scope.ad.billingManager.managementTool = data.managementTool;
                            $scope.ad.billingManager.companyId = data.managerCompanyId;
                            $scope.ad.billingManager.loading = false;
                            $scope.ad.billingManager.loaded = true;
                        }
                    },
                    data => {
                        if (data.status === 404) {
                            $scope.ad.billingManager.loaded = true;
                        }
                        $scope.ad.billingManager.loading = false;
                    });
            } else {
                return Promise.resolve();
            }
        };

        $scope.getStoreAppView = function(storeApp) {
                    for (var i = 0; i < $scope.ad.view.storeAppsView.length; i++)
                        if ($scope.ad.view.storeAppsView[i].getModel() === storeApp)
                            return $scope.ad.view.storeAppsView[i];
                    return null;
                };

        $scope.toggleManagerMode = function (nextIsInvoice) {
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/managerMode.html',
                        controller: 'ManagerModeCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["ad"] = $scope.ad;
                                const timer = $timeout(() => {
                                    angular.element('#input-focus').trigger('focus');
                                },250);

                                timers.push(timer);
                                return tableModel;
                            }
                        }
                    };

                    var d = $dialog.dialog(opts);
                    d.open().then(function (result) {
                        if (result) { //toggle accepted
                            $scope.ad.managerMode = !$scope.ad.managerMode;
                            Helper.managerMode = $scope.ad.managerMode;
                            if ($scope.ad.managerMode) {
                                $scope.goToDomain('flexyBeauty','onlinePayment');
                            } else {
                                if ($scope.ad.domain !== "planningPos") {
                                    $scope.goToDomain("planningPos");
                                } else {
                                    $scope.loadAgendaNotificationParameters('internet');
                                }
                            }
                        } else {
                            if (nextIsInvoice) {
                                $scope.initDisplayStartWindow();
                            }

                            if ($scope.ad.domain !== "planningPos" && !$scope.ad.managerMode) {
                                $scope.goToDomain("planningPos", "dashboard");
                            }
                        }
                    });
                };

                // CODE CONTROLLER START
                if (Loader.forceReload) {
                    $window.location.reload();
                    return;
                }
                $scope.ad.domain = $routeParams.domain;
                $scope.ad.ssDomain = $routeParams.ssDomain;

                $scope.loadDomainAndSubDomain = function () {

                    let search = $location.search();

                    if (search && search.sDm) {

                        $scope.ad.sDm = search.sDm;

                    } else if ($scope.ad.domain === "planningPos") {

                        $scope.ad.sDm = "dashboard";//default

                        $location.search("sDm", "dashboard");

                    } else if ($scope.ad.domain === "flexyBeauty") {

                        $scope.ad.sDm = "flexyStore";//default

                        $location.search("sDm", "flexyStore");

                    } else if ($scope.ad.domain === "humanResource") {

                        $scope.ad.sDm = "team";//default

                        $location.search("sDm", "team");

                    }

                };

                $scope.getStoreAppsView = function () {
                    return $scope.ad.view.storeAppsView;
                };

                $scope.initCompanyView = Decorators.timeMeasureDecorator(
                    () => {
                        var storeApps = StoreAppData.getActiveList();
                        for (var i = 0; i < storeApps.length; i++)
                            $scope.ad.view.storeAppsView.push(new StoreAppView(storeApps[i], StoreAppData.getIndexOf(storeApps[i]), $scope));
                        $scope.ad.view.companyView = new CompanyView($scope.ad.loggedUser.company, CompanyData.getIndexOf($scope.ad.loggedUser.company), $scope);
                        $scope.ad.view.subscriptions.sub.annual = $scope.ad.view.companyView.getSubscriptionViewByStoreAppViewCode('annual');
                        $scope.ad.view.companyView.updateSubscriptions();
                        let companyType = $scope.ad.loggedUser.company.type
                        $rootScope.readOnly = companyType === CompanyTypes.MIGRATION.value || companyType === CompanyTypes.CANCELED.value;
                        $rootScope.isCancel = companyType === CompanyTypes.CANCELED.value;
                        $rootScope.isBlockedOrBillingBlocked = companyType === CompanyTypes.BLOCKED.value || companyType === CompanyTypes.BILLINGBLOCKED.value
                    },
                    TimeMeasures.INIT_COMPANY_VIEW
                );

                $scope.initTheme = function () {
                    let agendaApp = AppData.getAppByCode('agenda');
                    let themeName = Constants.defaultTheme;

                    if (agendaApp !== null) {
                        let selectedTheme = agendaApp.getAppAttribute('themeName');
                        if (selectedTheme !== null && selectedTheme.value) {
                            themeName = selectedTheme.value;
                        }
                    }

                    $scope.ad.themeClass = Constants.themes[themeName] || "theme-" + Constants.defaultTheme;
                    $scope.changeTheme(themeName);
                };

                $scope.changeTheme = function (themeName) {
                    if (themeName) {
                        var head = top.document.getElementsByTagName("head")[0];
                        if (head) {
                            var styles = top.document.getElementsByName("theme");
                            if (styles && styles.length != 0) {
                                for (var i = 0; i < styles.length; i++) {
                                    if (styles[i].getAttribute("id") !== themeName) {
                                        styles[i].setAttribute("disabled", "true");
                                    } else {
                                        styles[i].removeAttribute("disabled");
                                    }
                                }
                            }
                        }
                    }
                };

                $scope.loadExternalServices = Decorators.timeMeasureDecorator(
                    () => {
                        const activeOffer = $scope.ad.loggedUser.company ? $scope.ad.loggedUser.company.activeOffer : null;
                        ExternalServiceLoader.initFullStory($scope.ad.loggedUser, $scope.ad.currentUser);
                        ExternalServiceLoader.initBugsnag($scope.ad.loggedUser);
                        ExternalServiceLoader.initChameleon($scope.ad.loggedUser, activeOffer ? activeOffer.offerCode : null);
                        ExternalServiceLoader.initLokalise();
                        ExternalServiceLoader.initIntercom($scope.ad.loggedUser, activeOffer, $scope.getIntercomAppId());
                    },
                    TimeMeasures.EXTERNAL_SERVICES_LOADING
                );

                $scope.registerEndForGlobalTimeOnFailure = function() {
                    if ($rootScope.canAccessNewLoading) {
                        MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME_STARTUP);
                    } else {
                        MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME);
                    }
                    MonitoringSrv.logHealth(MonitoringApplication.PROBACKOFFICE, MonitoringHealthState.KO, JSON.stringify(MeasureStore));
                };

                $scope.errorAuthentication = function (securityError, unauthorizedUser) {
                    $scope.registerEndForGlobalTimeOnFailure();

                    $scope.ad.dataLoadedError = true;
                    $scope.ad.unauthorizedUser = unauthorizedUser;
                    if (securityError) {
                        Auth.logout();
                        let absUrl = $location.absUrl();
                        if (absUrl.indexOf("/connect/") !== -1) {
                            $window.open("/connect", "_self");
                        } else {
                            $window.open("/", "_self");
                        }
                    }
                };

                $scope.checkVersion = function () {
                    if (angular.isDefined($rootScope.versionInterval)) {
                        return;
                    }

                    $rootScope.versionInterval = $interval(
                        () => {
                            EnvironmentSrv.getVersion().then(
                                (version) => {
                                    if ($scope.ad.loggedUser.serverIdentification.version !== version) {
                                        $rootScope.displayReloadMessage = true;
                                        $scope.stopCheckVersion();
                                    }
                                },
                                (error) => {
                                    if (error.status === 401) {
                                        $scope.stopCheckVersion();
                                        Auth.logout();
                                    } else {
                                        console.warn("FlexyBeautyApp.controllers - checkVersion " + error.message);
                                    }
                                });
                        }, Environment_Constant.VERSION_CHECK_FREQUENCY_MILLISECOND);
                };

                $scope.stopCheckVersion = function () {
                    if (angular.isDefined($rootScope.versionInterval)) {
                        $interval.cancel($rootScope.versionInterval);
                        $rootScope.versionInterval = undefined;
                    }
                };

                $scope.onAuthenticationLost = function () {
                    $scope.logout(true);
                };

                $scope.hideNewLoadingAlert = function() {
                    const hideTextTimer = $timeout( () => {
                        $rootScope.hideNewLoadingText = true;
                    }, 1500);

                    const hideAlertTimer = $timeout(() => {
                        $rootScope.hideNewLoadingPop = true;
                        $timeout.cancel(hideTextTimer);
                        $timeout.cancel(hideAlertTimer);
                    }, 2500);
                };

                $scope.getKiuteProAppIframeUrl = () => {
                    let iframeUrl = Constants.KIUTE_PRO_APP.local;

                    if (!$scope.ad.loggedUser.serverIdentification) {
                        return $sce.trustAsResourceUrl(iframeUrl);
                    }

                    if ($scope.ad.loggedUser.serverIdentification.applicationId === 'bsiflexyprod') {
                        iframeUrl = Constants.KIUTE_PRO_APP.prod;
                    } else {
                        iframeUrl = Constants.KIUTE_PRO_APP.staging;
                    }
                    return $sce.trustAsResourceUrl(iframeUrl);
                };

                $scope.loadData = function () {
                    Loader.load(function () {
                            $scope.ad.loggedUser = UserData.getLoggedUser();

                            // FIXME: OneA-in-Core feauture
                            // $scope.ad.kiuteProAppIframeUrl = $scope.getKiuteProAppIframeUrl();

                            Auth.createChannel($scope.ad.currentUser).then(
                                function (user) {

                                    $scope.loadDomainAndSubDomain();
                                    $scope.ad.currentUser = user;
                                    let afterLocalLoad = function () {
                                        try {
                                            CurrencyManager.setByCurrency($scope.ad.loggedUser.company.currency);
                                            $scope.initCompanyView();
                                            DateSrv.doReload();
                                            if ($scope.ad.loggedUser.serverIdentification && $scope.ad.loggedUser.serverIdentification.currentDate && IS_PERIODIC_GET_USER_ACTION_ACTIVATED) {
                                                UserActionManager.currentPopDate = $scope.ad.loggedUser.serverIdentification.currentDate;
                                                $scope.applyNewUserActionPopInterval(Constants.USER_ACTION_DATE_INTERVAL_NORMAL_ACTIVITY_IN_MILLI_SECONDS);
                                                Idle.watch();
                                            }

                                            $scope.ad.managerMode = !$scope.ad.loggedUser.hasManagerPassword || Auth.isAdmin();
                                            Helper.managerMode = $scope.ad.managerMode;
                                            $scope.loadSubscriptionStoreAppActivities();
                                            $scope.loadIZettleAppAttribute();
                                            $scope.ad.currentSiteName = SiteData.defaultSite.name;
                                            $scope.ad.companyMigrationSettings = CompanyMigrationSettingsData.companyMigrationSettings;
                                            $scope.displayNeedToUpdateMangopay();
                                            $scope.displayBannerPopUp();
                                            $scope.initBannerStyle();
                                            $scope.ad.dataLoaded = true;
                                            $scope.initTheme();
                                            $scope.initDisplayStartWindow();
                                            $scope.loadOrCountNotification();

                                            $(document).ready(function () {
                                                if ($scope.ad.currentSiteName && $scope.ad.currentSiteName != undefined)
                                                    var titlePart = gettextCatalog.getString("Application");
                                                document.title = $scope.ad.currentSiteName + " - " + $scope.ad.brand.label + " - " + titlePart;
                                                $scope.removeMetaDescription();
                                            });

                                            let setAttributeOnLiveEdit = function () {
                                                if ($('#lokalise-live-js-panel').is(':visible')) { //if the container is visible on the page
                                                    $("#lokalise-live-js-panel").attr("generalliveedit", true);
                                                } else {
                                                    setTimeout(setAttributeOnLiveEdit, 50); //wait 50 ms, then try again
                                                }
                                            }
                                            angular.element(document).ready(function () {
                                                setAttributeOnLiveEdit();
                                            });

                                            //End activate
                                            if ($scope.ad.loggedUser.company.type === CompanyTypes.BLOCKED ||
                                                $scope.ad.loggedUser.company.type === CompanyTypes.BILLINGBLOCKED) {
                                                $scope.goToDomain(Constants.APP_SUB_DOMAIN.flexyBeauty, Constants.APP_SUB_DOMAIN.paymentMode);
                                            } else {
                                                $scope.displayMigrationInfoCountdown('appLoading');
                                                const isPlanningPosDomain = $scope.ad.absUrl.indexOf("/app/" + Constants.APP_DOMAIN.planningPos) !== -1;
                                                const isPlanningSubDomain = $scope.ad.absUrl.indexOf("sDm=" + Constants.APP_SUB_DOMAIN.planning) !== -1;
                                                if (isPlanningPosDomain && !isPlanningSubDomain) {
                                                    $scope.goToSubDomain(Constants.APP_SUB_DOMAIN.planning);
                                                } else if (!isPlanningPosDomain) {
                                                    $scope.goToDomain(Constants.APP_DOMAIN.planningPos, Constants.APP_SUB_DOMAIN.planning);
                                                }
                                            }

                                            let isChromium = window.chrome, vendorName = window.navigator.vendor;
                                            let isWebkit = 'WebkitAppearance' in document.documentElement.style;
                                            if (navigator.userAgent.indexOf("Mobile") !== -1) {
                                                if (!isWebkit)//no webkit on mobile alert !
                                                    MessageSrv.send("alert", gettextCatalog.getString("Vous n'utilisez pas Chrome !") + '<br/>' + gettextCatalog.getString("{{brandLabel}} nécessite le navigateur Chrome.", {brandLabel: $scope.ad.brand.label}) + '<a href="https://www.google.fr/chrome" target="_blank"><i class="fal fa-download"></i>' + gettextCatalog.getString("Télécharger") + '</a>');
                                            } else if ((!(isChromium !== null && isChromium !== undefined && vendorName === "Google Inc.") && (navigator.userAgent.indexOf("Chrome") === -1 && navigator.userAgent.indexOf("CriOS") === -1)))
                                                MessageSrv.send("alert", gettextCatalog.getString("Vous n'utilisez pas Chrome !") + '<br/>' + gettextCatalog.getString("{{brandLabel}} nécessite le navigateur Chrome.", {brandLabel: $scope.ad.brand.label}) + '<a href="https://www.google.fr/chrome" target="_blank"><i class="fal fa-download"></i>' + gettextCatalog.getString("Télécharger") + '</a>');
                                            console.timeEnd("Application");

                                            const timer = $timeout(() => {
                                                let warning = gettextCatalog.getString('Vous devez recharger l\'application');
                                                MessageSrv.send("warning", warning + " !");
                                            }, 86400000);

                                            timers.push(timer);

                                            $scope.loadAgendaNotificationParameters('internet');

                                            let currentperiod = new PeriodStat(StatPeriodType.CURRENT, new moment(), new moment(), PeriodType.DAY);
                                            $scope.loadAgendaNotification(currentperiod);

                                            $scope.checkVersion();

                                            if ($rootScope.canAccessNewLoading) {
                                                MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME_STARTUP);
                                            } else {
                                                MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME);
                                            }
                                        } catch (e) {
                                            $scope.registerEndForGlobalTimeOnFailure();
                                        }

                                        $scope.loadExternalServices();
                                    };

                                    if ($scope.ad.loggedUser) {
                                        afterLocalLoad();
                                    } else {
                                        $scope.ad.dataLoadedError = true;
                                        $scope.registerEndForGlobalTimeOnFailure();
                                    }
                                },
                                function () {
                                    $scope.errorAuthentication(false);
                                }
                            );
                        },
                        function (securityError, companyTypeCanceled) {
                            $scope.errorAuthentication(securityError, companyTypeCanceled);
                        },
                        function () {
                            $rootScope.newLoadingInProgress = false;
                            $scope.hideNewLoadingAlert();

                            if (Loader.loaded) {
                                $rootScope.$broadcast('onGlobalLoadingFinished');
                            }
                        });
                };

                $scope.removeMetaDescription = function () {
                    let metaTags = document.getElementsByTagName('meta');
                    if (metaTags) {
                        let metaDescription = metaTags['description'];
                        if (metaDescription) {
                            metaDescription.remove();
                        }
                    }
                };

                $scope.getUserTooltip = function () {
                    let noPaimentWay = gettextCatalog.getString('Aucun moyen de paiement!');
                    let userTooltip = '';
                    if ($scope.ad && $scope.ad.loggedUser) {
                        let company = $scope.ad.loggedUser.company;
                        let currentUserEmail = $scope.ad.currentUser ? $scope.ad.currentUser.email : '';
                        if (company) {
                            if (company.companyPaymentData != null && company.companyPaymentData.isValid) {
                                userTooltip = currentUserEmail;
                            } else {
                                userTooltip = noPaimentWay + ' ' + loggedUser.company.name + ' ' + currentUserEmail;
                            }
                        }
                    }
                    return userTooltip;
                };
                $scope.formatTime = function (time) {
                    let timeMoment = new moment().hour(time.hour).minute(time.minute);
                    return timeMoment.format("LT");
                };

                $scope.loadAgendaNotificationParameters = function (type) {
                    $scope.ad.view.notificationDisplayParameters = {
                        type: type,
                        beginMoment: new moment(),
                        endMoment: new moment(),
                        periodType: PeriodType.DAY,
                        typeModification: TypeOfModification.ALL,
                        displayAgendaNotifs: true
                    }
                };

                $scope.loadAgendaNotification = function (currentPeriod) {
                    $scope.userActions = [];

                    let currentDate = $filter('date')(currentPeriod.arrayOfDays[0].getDate(), 'yyyy-MM-dd');

                    let todayDate = new Date();
                    let twoWeeksAgoDate = $filter('date')(todayDate.setDate(todayDate.getDate() - 14), 'yyyy-MM-dd');

                    let absUrl = $location.absUrl();

                    if (currentDate <= twoWeeksAgoDate && absUrl.indexOf("/fxbAdmin/") === -1)
                        $scope.ad.view.notificationDisplayParameters.displayAgendaNotifs = false;
                    else {
                        $scope.ad.view.notificationDisplayParameters.displayAgendaNotifs = true;

                        UserActionSrv.getUserActionBooking(currentDate)
                            .then((data) => {
                                let userActionsRes = data ? data.userActions : {};
                                if (userActionsRes) {
                                    let labelHrModified = gettextCatalog.getString("Modification du personnel de la prestation"),
                                        labelPrModified = gettextCatalog.getString("Modification de l'équipement de la prestation"),
                                        labelTimeBsModified = gettextCatalog.getString("Modification de l'horaire de la prestation"),
                                        labelBsAdded = gettextCatalog.getString("Ajout d'une prestation à la réservation"),
                                        labelBsDeleted = gettextCatalog.getString("Suppression d'une prestation de la réservation"),
                                        labelNotFoundCustomer = gettextCatalog.getString("Client introuvable"),
                                        labelPassageCustomer = gettextCatalog.getString("Un client de passage"),
                                        labelDateServiceModified = gettextCatalog.getString("Modification du jour de la réservation"),
                                        labelTimeServiceModified = gettextCatalog.getString("Modification de l'horaire de la réservation");
                                    for (let i = 0; i < userActionsRes.length; i++) {

                                        let ua = {
                                            globalType: userActionsRes[i].globalType,
                                            hr: HumanResourceData.getById(userActionsRes[i].authorId),
                                            actionDate: new Date(userActionsRes[i].actionDate),
                                            booking: {
                                                currentVersion: null,
                                                previousVersion: null
                                            },
                                            updateType: null,
                                            isLastmodification: true
                                        };

                                        for (let j = 0; j < userActionsRes[i].objectModifications.length; j++) {
                                            let currentDayHr,
                                                previousDayHr,
                                                previousDayPr,
                                                currentDayPr,
                                                currentHr,
                                                previousHr,
                                                currentPr,
                                                previousPr,
                                                objModifications = userActionsRes[i].objectModifications[j];

                                            try {
                                                let addServiceModifications = function (currentBookingService, previousBookingService) {
                                                    try {

                                                        if (previousBookingService == null) {
                                                            currentDayHr = DayHrData.getById(currentBookingService.dayHrId);
                                                            if (currentDayHr && currentDayHr.humanResourceId != null) {
                                                                currentHr = HumanResourceData.getById(currentDayHr.humanResourceId);
                                                                ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelBsAdded + ": '" + currentBookingService.label + "' : " + currentHr.label + " " + $scope.formatTime(currentBookingService.period.start) + "-" + $scope.formatTime(currentBookingService.period.end);
                                                            }
                                                        } else if (currentBookingService && previousBookingService && currentBookingService.isDeleted) {
                                                            currentDayHr = DayHrData.getById(currentBookingService.dayHrId);
                                                            if (currentDayHr && currentDayHr.humanResourceId != null) {
                                                                currentHr = HumanResourceData.getById(currentDayHr.humanResourceId);
                                                                ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelBsDeleted + ": '" + currentBookingService.label + "' : " + currentHr.label + " " + $scope.formatTime(previousBookingService.period.start) + "-" + $scope.formatTime(previousBookingService.period.end);
                                                            }
                                                        } else {
                                                            if (currentBookingService.dayHrId && previousBookingService.dayHrId && currentBookingService.dayHrId !== previousBookingService.dayHrId) {
                                                                currentDayHr = DayHrData.getById(currentBookingService.dayHrId);
                                                                previousDayHr = DayHrData.getById(previousBookingService.dayHrId);
                                                                if (currentDayHr && previousDayHr && currentDayHr.humanResourceId !== previousDayHr.humanResourceId) {
                                                                    currentHr = HumanResourceData.getById(currentDayHr.humanResourceId);
                                                                    previousHr = HumanResourceData.getById(previousDayHr.humanResourceId);
                                                                    ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelHrModified + " '" + currentBookingService.label + "' : " + previousHr.label + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + currentHr.label;
                                                                }
                                                            } else if ((previousBookingService.dayHrId && !currentBookingService.dayHrId)) {
                                                                previousDayHr = DayHrData.getById(previousBookingService.dayHrId);
                                                                if (previousDayHr && previousDayHr.humanResourceId) {
                                                                    previousHr = HumanResourceData.getById(previousDayHr.humanResourceId);
                                                                    ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelHrModified + " '" + previousBookingService.label + "' : " + previousHr.label + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + "???";
                                                                }
                                                            } else if (currentBookingService.dayHrId && previousBookingService.period && !$scope.comparePeriods(previousBookingService.period, currentBookingService.period)) {
                                                                ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelTimeBsModified + " : " + $scope.formatTime(previousBookingService.period.start) + "-" + $scope.formatTime(previousBookingService.period.end) + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + $scope.formatTime(currentBookingService.period.start) + "-" + $scope.formatTime(currentBookingService.period.end);
                                                            }

                                                            if (currentBookingService.dayPrId && previousBookingService.dayPrId && currentBookingService.dayPrId !== previousBookingService.dayPrId) {
                                                                currentDayPr = DayPrData.getById(currentBookingService.dayPrId);
                                                                previousDayPr = DayPrData.getById(previousBookingService.dayPrId);
                                                                if (currentDayPr && previousDayPr && currentDayPr.physicalResourceId !== previousDayPr.physicalResourceId) {
                                                                    currentPr = PhysicalResourceData.getById(currentDayPr.physicalResourceId);
                                                                    previousPr = PhysicalResourceData.getById(previousDayPr.physicalResourceId);
                                                                    ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelPrModified + " '" + currentBookingService.label + "' : " + previousPr.label + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + currentPr.label;
                                                                }
                                                            } else if ((previousBookingService.dayPrId && !currentBookingService.dayPrId)) {
                                                                previousDayPr = DayPrData.getById(previousBookingService.dayPrId);
                                                                if (previousDayPr && previousDayPr.physicalResourceId) {
                                                                    previousPr = PhysicalResourceData.getById(previousDayPr.physicalResourceId);
                                                                    ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelPrModified + " '" + previousBookingService.label + "' : " + previousPr.label + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + "???";
                                                                }
                                                            } else if (currentBookingService.dayPrId && previousBookingService.period && !$scope.comparePeriods(previousBookingService.period, currentBookingService.period)) {
                                                                ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelTimeBsModified + " : " + $scope.formatTime(previousBookingService.period.start) + "-" + $scope.formatTime(previousBookingService.period.end) + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + $scope.formatTime(currentBookingService.period.start) + "-" + $scope.formatTime(currentBookingService.period.end);
                                                            }
                                                        }
                                                    } catch (err) {
                                                        console.error("Error while processing the userAction : CurrentBookingServiceId : " + (currentBookingService ? currentBookingService.id : "null ") + ", PreviousBookingServiceId : " + (previousBookingService ? previousBookingService.id : "null "));
                                                    }
                                                };

                                                if (objModifications.currentVersion.objectType === "Booking") {
                                                    ua.booking.currentVersion = objModifications.currentVersion;
                                                    ua.booking.currentVersion.date = DayData.getById(objModifications.currentVersion.dayId).getDate();

                                                    let currentCustomer = objModifications.currentVersion.customerId ? CustomerData.getById(objModifications.currentVersion.customerId) : null;


                                                    ua.booking.currentVersion.customerLabel = objModifications.currentVersion.customerId ? (currentCustomer ? (currentCustomer.firstName + " " + currentCustomer.lastName) : labelNotFoundCustomer) : labelPassageCustomer;
                                                    ua.booking.previousVersion = objModifications.previousVersion;
                                                    if (objModifications.previousVersion) {
                                                        let previousCustomer = objModifications.previousVersion.customerId ? CustomerData.getById(objModifications.previousVersion.customerId) : null;

                                                        ua.booking.previousVersion.customerLabel = (objModifications.previousVersion.customerId) ? (previousCustomer ? (previousCustomer.firstName + " " + previousCustomer.lastName) : labelNotFoundCustomer) : labelPassageCustomer;
                                                        ua.booking.previousVersion.date = DayData.getById(objModifications.previousVersion.dayId).getDate();
                                                    }

                                                    if (userActionsRes[i].globalType === "update" && objModifications.currentVersion && objModifications.previousVersion) {
                                                        ua.updateType = "";

                                                        let indexBooking = BookingData.getIndexOf(BookingData.getById(objModifications.currentVersion.id));
                                                        if (indexBooking === -1) {
                                                            ua.isLastmodification = false;
                                                        }

                                                        if (objModifications.currentVersion.dayId !== objModifications.previousVersion.dayId) {

                                                            let currentDay = DayData.getById(objModifications.currentVersion.dayId),
                                                                previousDay = DayData.getById(objModifications.previousVersion.dayId);
                                                            if (currentDay && previousDay) {
                                                                let currentMoment = currentDay.getMomentDate(),
                                                                    previousMoment = previousDay.getMomentDate();
                                                                if (currentMoment && previousMoment) {
                                                                    ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelDateServiceModified + " : " + previousMoment.format("L") + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + currentMoment.format("L");
                                                                }
                                                            }
                                                        }
                                                        if (objModifications.currentVersion.period.start.hour !== objModifications.previousVersion.period.start.hour ||
                                                            objModifications.currentVersion.period.start.minute !== objModifications.previousVersion.period.start.minute ||
                                                            objModifications.currentVersion.period.end.hour !== objModifications.previousVersion.period.end.hour ||
                                                            objModifications.currentVersion.period.end.minute !== objModifications.previousVersion.period.end.minute) {
                                                            ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelTimeServiceModified + " : " + $scope.formatTime(objModifications.previousVersion.period.start) + "-" + $scope.formatTime(objModifications.previousVersion.period.end) + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + $scope.formatTime(objModifications.currentVersion.period.start) + "-" + $scope.formatTime(objModifications.currentVersion.period.end);
                                                        }

                                                        for (let k = 0; k < objModifications.currentVersion.bookingServicesDetail.length; k++) {
                                                            let currentBookingService = objModifications.currentVersion.bookingServicesDetail[k];
                                                            if (currentBookingService.isPackage === false) {
                                                                for (let l = 0; l < objModifications.previousVersion.bookingServicesDetail.length; l++) {
                                                                    let previousBookingService = objModifications.previousVersion.bookingServicesDetail[l];

                                                                    if (currentBookingService.idInBooking === previousBookingService.idInBooking) {
                                                                        addServiceModifications(currentBookingService, previousBookingService);
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    ua.booking.currentVersion.bookingLabels = "";
                                                    for (var k = 0; k < objModifications.currentVersion.bookingServicesDetail.length; k++) {
                                                        ua.booking.currentVersion.bookingLabels += (ua.booking.currentVersion.bookingLabels !== "" ? ", " : "") + objModifications.currentVersion.bookingServicesDetail[k].label;
                                                    }
                                                    if (ua.booking.previousVersion) {
                                                        ua.booking.previousVersion.bookingLabels = "";
                                                        for (let k = 0; k < objModifications.previousVersion.bookingServicesDetail.length; k++) {
                                                            ua.booking.previousVersion.bookingLabels += (ua.booking.previousVersion.bookingLabels !== "" ? ", " : "") + objModifications.previousVersion.bookingServicesDetail[k].label;
                                                        }
                                                    }
                                                } else if (objModifications.currentVersion.objectType === "BookingService") {
                                                    if (userActionsRes[i].globalType === "update" && objModifications.currentVersion && objModifications.previousVersion) {
                                                        if (objModifications.currentVersion.isPackage === false && objModifications.currentVersion.pkgId) {
                                                            addServiceModifications(objModifications.currentVersion, objModifications.previousVersion);
                                                        }
                                                    }
                                                }
                                            } catch (err) {
                                                console.info("Error getting planning update " + err);
                                            }
                                        }
                                        $scope.userActions.push(ua);
                                    }
                                }
                            })
                            .catch((error) => {
                                bugsnag.notify("UserActionSrv.getUserActionBooking - Error during fetching userAction booking", `GetUserActionBooking failure. Error : ${error.message}`, {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
                            });
                    }
                };

                $scope.comparePeriods = function (period1, period2) {
                    return period1 != null && period2 != null && $scope.compareTimes(period1.start, period2.start) && $scope.compareTimes(period1.end, period2.end);
                };

                $scope.compareTimes = function (time1, time2) {
                    return time1 && time2 && time1.hour === time2.hour && time1.minute === time2.minute;
                };


                $scope.toggleLiveEdit = function () {
                    if ($scope.ad.domain !== 'webSite') {
                        $("div[generalliveedit=true]").toggle();
                    } else {
                        $("div[generalliveedit=true]").hide();
                        //$("div[websiteliveedit=true]", $('#webSiteFrame').html()).toggle();
                        $('#webSiteFrame').contents().find("div[websiteliveedit=true]").toggle()
                    }
                };

                $scope.hideGeneralLiveEdit = function () {
                    $("div[generalliveedit=true]").hide();
                };

                $scope.goToWebSiteDomain = function () {
                    if (OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_WEBSITE)) {
                        $scope.hideGeneralLiveEdit();
                        $scope.goToDomain('webSite');
                    }
                };

                $scope.checkMarketplaceComplianceIfNeeded = function() {
                    if (!$scope.ad.isMarketplaceCompliant && $scope.ad.loggedUser.company) {
                        let marketPlaceCompliant = new MarketPlaceSpecifications.MarketPlaceCompliant();
                        $scope.ad.isMarketplaceCompliant = marketPlaceCompliant.isSatisfiedBy($scope.ad.loggedUser.company, $scope.ad.managerMode);
                    }
                    return $scope.ad.isMarketplaceCompliant;
                };

                $scope.navigateToNgApp = function (data) {
                    $scope.ngAppCustomerIframe = document.getElementById("ngAppCustomerIframe");
                    if ($scope.ngAppCustomerIframe && $scope.ngAppCustomerIframe.contentWindow) {
                        $scope.ngAppCustomerIframe.contentWindow.postMessage(data, "*");
                    }
                };

                $scope.tabAlreadyOpen = function() {
                    if ($rootScope.canAccessDoubleTabBlocked) {
                        localStorage.openpages = Date.now();
                        window.addEventListener('storage', function (event) {
                            let localStorageVariable = 'page_available_' + Auth.getCompanyCode() + '_admin_' + Auth.isAdmin();
                            if (event.key == "openpages") {
                                localStorage[localStorageVariable] = Date.now();
                                $scope.ad.isAlreadyOpenTab = false;
                            }
                            if (event.key == localStorageVariable) {
                                $scope.ad.isAlreadyOpenTab = true;
                                $scope.setDisplayStartWindow(true);
                            }
                        }, false);
                    }
                }

                if (!$scope.ad.dataLoaded) {
                    LaunchDarklyFeatureFlagSrv.query(
                        () => {
                            $rootScope.canAccessNewLoading = LaunchDarklyFeatureFlagData.canAccessNewLoading;
                            $rootScope.canAccessKiuteProApp = LaunchDarklyFeatureFlagData.canAccessKiuteProApp;
                            $rootScope.canAccessDoubleTabBlocked = LaunchDarklyFeatureFlagData.canAccessDoubleTabBlocked;

                            if ($rootScope.canAccessNewLoading) {
                                $rootScope.newLoadingInProgress = true;
                                MeasureStore.registerStart(TimeMeasures.MODEL_GLOBAL_TIME_STARTUP);
                            } else {
                                MeasureStore.registerStart(TimeMeasures.MODEL_GLOBAL_TIME);
                            }

                            $scope.tabAlreadyOpen();
                            if (!$scope.ad.isAlreadyOpenTab) {
                                $scope.loadData();
                            }
                        },
                        (error) => {
                            $scope.ad.dataLoadedError = true;
                            $scope.registerEndForGlobalTimeOnFailure();
                            if(error.status === 401) {
                                Auth.logout();
                            }
                        }
                    );
                } else {
                    $scope.loadDomainAndSubDomain();
                    $scope.ad.loggedUser = UserData.getLoggedUser();
                    $scope.loadSubscriptionStoreAppActivities();
                    $scope.ad.currentSiteName = SiteData.defaultSite.name;
                    if(NotificationData.unreadNotifications !== undefined) {
                        $scope.ad.view.nbNotificationsUnread = NotificationData.unreadNotifications;
                    } else{
                        $scope.loadOrCountNotification();
                    }
                    $scope.initCompanyView();
                    $scope.initTheme();
                }

                $scope.copyToClipboard = function (name) {
                    let copyElement = document.getElementById(name);
                    copyElement.select();
                    document.execCommand('copy');
                }

                $scope.$on('$destroy', function () {
                    onNotificationDestroy();
                    fxbInvalidTokenDestroy();
                    fxbInvalidChannelDestroy();

                    Timers.cancel(timers, intervals);
                });

                $scope.$on('IdleStart', function() {
                    console.info(`Idle time detected : change interval to userAction date from ${Constants.USER_ACTION_DATE_INTERVAL_NORMAL_ACTIVITY_IN_MILLI_SECONDS} ms to ${Constants.USER_ACTION_DATE_INTERVAL_LOW_ACTIVITY_IN_MILLI_SECONDS} ms`);
                    $scope.applyNewUserActionPopInterval(Constants.USER_ACTION_DATE_INTERVAL_LOW_ACTIVITY_IN_MILLI_SECONDS);
                });

                $scope.$on('IdleEnd', function() {
                    console.info(`Activity renew detected: change interval to userAction date from ${Constants.USER_ACTION_DATE_INTERVAL_LOW_ACTIVITY_IN_MILLI_SECONDS} ms to ${Constants.USER_ACTION_DATE_INTERVAL_NORMAL_ACTIVITY_IN_MILLI_SECONDS} ms`);
                    $scope.applyNewUserActionPopInterval(Constants.USER_ACTION_DATE_INTERVAL_NORMAL_ACTIVITY_IN_MILLI_SECONDS);
                });

                $scope.applyNewUserActionPopInterval = (interval) => {
                    UserActionManager.userActionDateIntervalInMilliSecond = interval;
                    UserActionManager.stopPopInterval();
                    intervals.splice(timers.indexOf($scope.popInterval), 1);
                    UserActionManager.executeUserActionPop($scope.onAuthenticationLost);
                    $scope.popInterval = UserActionManager.startUserActionPop($scope.onAuthenticationLost, interval);
                    intervals.push($scope.popInterval);
                }

                $scope.isReadOnly = function (){
                    return $rootScope.readOnly;
                };

                $scope.isCanceled = function() {
                    return $rootScope.isCancel;
                }

                $scope.isBlockedOrBillingBlocked = function () {
                    return $rootScope.isBlockedOrBillingBlocked;
                }

                $scope.getBooksyUrl = function () {
                    const owner = $scope.ad.loggedUser
                    if (owner != null) {
                        const companyCode = owner.company ? owner.company.code : null

                        const booksyUrl = $scope.ad.brand.url.booksyUrl
                          + '?companyCode=' + companyCode
                        return $sce.trustAsResourceUrl(booksyUrl)
                    }
                }

                $scope.openBooksyLandingPage = function () {
                    let link = $scope.getBooksyUrl();
                    $window.open(link, '_blank');
                }

                $scope.isAdminNotGroup = function () {
                    return Auth.isAdminNotGroup();
                }

                $scope.setMigrationDisplayBanner = function(displayBanner) {
                    if ($scope.ad.companyMigrationSettings) {
                        CompanyMigrationSettingsSrv.displayBannerPopUp(displayBanner, function() {
                            $scope.ad.companyMigrationSettings.displayBannerPopUp = displayBanner;
                        });
                    }
                }

                $scope.displayNeedToUpdateMangopay = function () {
                    PaymentServiceSrv.getNeedToUpdateMangopay(function (response) {
                          if (response && response.needUpdateMangopay === true && !$scope.ad.loggedUser.company.type !== CompanyTypes.MIGRATION.value && !$scope.ad.loggedUser.company.type !== CompanyTypes.CANCELED.value) {
                              $dialog.dialog({
                                  backdrop: true,
                                  backdropClick: false,
                                  keyboard: true,
                                  templateUrl: '/partials/global/generalConfirmWithSpecificText.html',
                                  controller: 'DialogCtrl',
                                  resolve: {
                                      dialogsModel: function () {
                                          let tableModel = [];
                                          tableModel.important = gettextCatalog.getString("Suite à la fusion entre les banques Crédit du Nord et Société Général, vos coordonnées bancaires ne sont plus valides. Veuillez mettre à jour votre IBAN avant le ");
                                          tableModel.importantBold = gettextCatalog.getString("le 1er Juillet 2024");
                                          tableModel.importantBody = gettextCatalog.getString(" pour éviter toute interruption de service.");
                                          tableModel.subtext = gettextCatalog.getString("Attention, il faut être connecté en mode gestionnaire pour modifier ses coordonnées bancaires !")

                                          tableModel.yesMessage = $scope.ad.managerMode ? "Je modifie mon IBAN" : "Je me connecte en gestionnaire et je modifie mon IBAN";
                                          return tableModel;
                                      }
                                  }
                              }).open().then(function (result) {
                                  if (result) {
                                      $scope.ad.managerMode ? $scope.goToDomain('flexyBeauty', 'onlinePayment') : $scope.toggleManagerMode(true);
                                  }
                              });
                          }
                      }, function () {
                        return null;
                      }
                    )
                }

                $scope.displayBannerPopUp = function () {
                    if ($scope.ad.companyMigrationSettings && $scope.ad.companyMigrationSettings.displayBannerPopUp && $scope.showBanner()) {
                        const migrationDate = new Date($scope.ad.companyMigrationSettings.forceMigrationDate);
                        const options = { day: 'numeric', month: 'long', year: 'numeric', };
                        const formatedDate = migrationDate.toLocaleDateString('fr-FR', options);
                        $dialog.dialog({
                            backdrop: true,
                            backdropClick: false,
                            keyboard: true,
                            templateUrl: '/partials/global/generalConfirmWithSpecificText.html',
                            controller: 'DialogCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    let tableModel = [];
                                    tableModel.important = gettextCatalog.getString("Cette version du logiciel ");
                                    tableModel.importantBold = gettextCatalog.getString("Kiute by Booksy");
                                    tableModel.importantBody = gettextCatalog.getString(" s’arrête bientôt ! Afin de vous faire bénéficier de la nouvelle version de l’interface ");
                                    tableModel.importantSecondBold = gettextCatalog.getString("Booksy,");
                                    tableModel.importantEnd = gettextCatalog.getString(" votre compte sera migré le " + formatedDate + ".");
                                    tableModel.yesMessage = "J'ai compris";
                                    return tableModel;
                                }
                            }
                        }).open().then(function (result) {
                            if (result) {
                                $scope.setMigrationDisplayBanner(false);
                            }
                        });
                    }
                }

                $scope.computeDayDiffWithToday = function(date) {
                    const oneDayMilliSeconds = 24 * 60 * 60 * 1000;
                    return Math.floor((date - new Date()) / oneDayMilliSeconds);
                }

                $scope.numberDaysBeforeMigration = function () {
                    return $scope.computeDayDiffWithToday($scope.ad.companyMigrationSettings.forceMigrationDate);
                }

                $scope.showBanner = function () {
                    return $scope.ad.companyMigrationSettings && $scope.ad.companyMigrationSettings.forceMigrationDate
                        && LaunchDarklyFeatureFlagData.forceMigrationDate && $scope.numberDaysBeforeMigration() > 0;
                }

                $scope.initBannerStyle = function () {
                    if ($scope.showBanner()) {
                        $scope.ad.topHeaderPixel = '61px';
                        $scope.ad.bodyPixel = '101px';
                    }
                }

                $scope.initBannerStyle();

                $scope.displayMigrationInfoCountdown = function (origin) {
                    const currentSite = SiteData.defaultSite;
                    const migrationInformationDate = $scope.ad.companyMigrationSettings ? $scope.ad.companyMigrationSettings.migrationInformationDate : null;
                    const areMigrationInformationComplete = currentSite ? currentSite.areMigrationInformationComplete($scope.ad.addons.sub.websiteAccess, AppData.getAppByCode(AppCode.POS_APP)) : true;
                    const provideMigrationInfos = migrationInformationDate && LaunchDarklyFeatureFlagData.forceMigrationInfos;
                    const forcedToMigrate = $scope.ad.companyMigrationSettings && $scope.ad.companyMigrationSettings.forceMigrationDate && LaunchDarklyFeatureFlagData.forceMigrationDate;
                    if (($scope.ad.loggedUser.company.type !== CompanyTypes.CANCELED.value && $scope.ad.loggedUser.company.type !== CompanyTypes.MIGRATION.value) && ($scope.ad.companyMigrationSettings && (forcedToMigrate == null || !$scope.ad.companyMigrationSettings.displayBannerPopUp) && !areMigrationInformationComplete && (provideMigrationInfos || forcedToMigrate))) {
                        const countdown = $scope.computeDayDiffWithToday(migrationInformationDate);
                        const forcedRedirectionToSite = countdown <= 0 || forcedToMigrate;
                        if (forcedRedirectionToSite) {
                            $scope.goToDomain('site');
                        } else if (origin === 'pos') {
                            $scope.goToDomain('planningPos', 'pos');
                        }
                        $dialog.dialog({
                            backdrop: true,
                            backdropClick: false,
                            keyboard: true,
                            templateUrl: '/partials/global/generalConfirmWithSpecificText.html',
                            controller: 'DialogCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    let tableModel = [];
                                    if (countdown > 15 && !forcedRedirectionToSite) {
                                        tableModel.important = gettextCatalog.getString("Vous avez ");
                                        tableModel.importantBold = gettextCatalog.getString((countdown - 15) + " jours");
                                        tableModel.importantEnd = gettextCatalog.getString(" pour remplir les informations obligatoires dans la partie Établissement - Fiche descriptive");
                                    } else {
                                        tableModel.important = !forcedRedirectionToSite ? gettextCatalog.getString("Vous devez dès maintenant remplir les informations obligatoires dans la partie Établissement - Fiche descriptive") :
                                            gettextCatalog.getString("Afin de pouvoir utiliser votre caisse, merci de bien vouloir remplir les informations obligatoires dans la partie Établissement - Fiche descriptive");
                                    }
                                    tableModel.noMessage = !forcedRedirectionToSite ? "Plus Tard" : null;
                                    tableModel.yesMessage = "Mettre à jour";
                                    return tableModel;
                                }
                            }
                        }).open().then(function (action) {
                            if (action && !forcedRedirectionToSite) {
                                $scope.goToDomain('site');
                            }
                        });
                    } else if (origin === 'pos') {
                        $scope.goToDomain('planningPos', 'pos');
                    }
                };
            }])



// WEBPACK FOOTER //
// ./js/controllers/pro/AppCtrl.js